import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function deleteTag(params) {
  return request({
    url: `${v2Host}/tag/delete`,
    method: 'post',
    data: params
    // params: params
  })
}
